import React from 'react';
import './WorkCardStyles.css';
import WorkCard from './WorkCard';
import WorkCardData from './WorkCardData';

const Work = () => {
  return (
    <section className="work-showcase" aria-label="Project showcase">
      <div className="work-showcase-inner">
        {WorkCardData.map((project, index) => (
          <WorkCard key={project.title} index={index} {...project} />
        ))}
      </div>

      <footer className="work-showcase-footer">
        <p>More builds in progress.</p>
        <a href="#contact" className="work-footer-link">
          Start a conversation
          <span className="work-footer-arrow">→</span>
        </a>
      </footer>
    </section>
  );
};

export default Work;
